import { BasicPageTitle, BasicPageWrapper } from "@/Theme/basicElements";
import { NewOrderScenario, TNewOrderScenario } from "@/entities/new-order";
import { useParams } from "react-router-dom";
import { scenarioTitles } from "../model/consts";
import {
  DuplicateOrder,
  ExtendOrder,
  NewOrder,
  PromoteOrder,
} from "./scenarios";

export const CreateNewOrder = () => {
  const { scenario = NewOrderScenario.create } = useParams<{
    scenario: TNewOrderScenario;
  }>();

  const SCENARIO_ROUTES_MAP = {
    [NewOrderScenario.create]: <NewOrder />,
    [NewOrderScenario.duplicate]: <DuplicateOrder />,
    [NewOrderScenario.extend]: <ExtendOrder />,
    [NewOrderScenario.promote]: <PromoteOrder />,
  };

  return (
    <BasicPageWrapper>
      <BasicPageTitle>{scenarioTitles[scenario]}</BasicPageTitle>
      {SCENARIO_ROUTES_MAP[scenario]}
    </BasicPageWrapper>
  );
};
